import { render, staticRenderFns } from "./GridControls.vue?vue&type=template&id=80b2e7b0&scoped=true&"
import script from "./GridControls.vue?vue&type=script&lang=ts&"
export * from "./GridControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b2e7b0",
  null
  
)

export default component.exports